var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLocalShippingSharp = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.666 6.667h-2.5V3.333H.833v10.834H2.5c0 1.383 1.116 2.5 2.5 2.5 1.383 0 2.5-1.117 2.5-2.5h5c0 1.383 1.116 2.5 2.5 2.5 1.383 0 2.5-1.117 2.5-2.5h1.666V10zM5 15a.836.836 0 0 1-.834-.833c0-.459.375-.834.834-.834.458 0 .833.375.833.834A.836.836 0 0 1 5 15m11.25-7.083L17.883 10h-3.717V7.917zM15 15a.836.836 0 0 1-.834-.833c0-.459.375-.834.834-.834.458 0 .833.375.833.834A.836.836 0 0 1 15 15"
  })));
};
export default SvgLocalShippingSharp;